/** @format */

import { useContext, useEffect, useState } from 'react';
import { Box, Typography, Container, Popper } from '@mui/material';
import { COMPONENT_TITLE_SX } from './homeStyles';
import Guage from './Cards/Guage';
import { buildPayload } from '../../Library/appfilter.lib';
import { useAppContext } from '../../../store/store.app';
import { getRevBudget } from '../../../Services/service.home';
import { HomeContext } from './Home';
import { TABS_MAPPING } from './KPI/KPIContainer';
import { TouchApp } from '@mui/icons-material';

const ITEMS = [
  { id: 'room_revenue', title: 'Rooms' },
  { id: 'food_revenue', title: 'Food' },
  { id: 'bev_revenue', title: 'Beverage' },
  { id: 'other_fnb_revenue', title: 'F&B Others' },
  { id: 'spa_revenue', title: 'Spa' },
  { id: 'mod_revenue', title: 'MOD' },
];
function GuageContainer() {
  return (
    <Container
      maxWidth="lg"
      sx={{
        px: { xs: 0, sm: 2, md: 3 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mt: 2,
          position: 'relative',
        }}
      >
        <Box sx={{ position: 'absolute', left: 0 }}>
          <Tooltip />
        </Box>
        <Typography
          textAlign="center"
          variant="h6"
          color="text.disabled"
          sx={{
            ...COMPONENT_TITLE_SX,
            flexGrow: 1,
            minWidth: 0,
            overflowWrap: 'anywhere',
          }}
        >
          Top 6 Rev. Contributors vs Budget
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(2, minmax(0, 1fr))',
            sm: 'repeat(3, minmax(0, 1fr))',
            md: 'repeat(6, minmax(0, 1fr))',
          },
          columnGap: 1,
          rowGap: 1,
          mt: 2,
          width: '100%',
          minWidth: 0,
        }}
      >
        {ITEMS.map((item) => (
          <Chart key={item.id} kpiId={item.id} KpiName={item.title} />
        ))}
      </Box>
    </Container>
  );
}

function Chart(props) {
  const { kpiId, KpiName } = props;
  const [data, setData] = useState(null);
  const { activeTab } = useContext(HomeContext);

  const {
    appStore: { appFilters },
  } = useAppContext();

  const { PARAMETER, CALC_DATERANGE } = appFilters;

  const basePayload = {};

  const payload = {
    ...buildPayload(appFilters),
    ...basePayload,
  };

  async function fetchData() {
    try {
      const response = await getRevBudget(
        kpiId,
        TABS_MAPPING[activeTab],
        payload
      );
      setData(response.data);
    } catch (error) {
      console.error(' Top 5 Rev. Contributors vs Budget:', kpiId, activeTab);
    }
  }
  useEffect(() => {
    if (!CALC_DATERANGE || !PARAMETER) return;
    fetchData();
  }, [kpiId, activeTab, CALC_DATERANGE, PARAMETER]);
  return <Guage key={kpiId} name={KpiName} data={data} />;
}

function Tooltip() {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        sx={{
          color: 'text.disabled',
          cursor: 'pointer',
          zIndex: 1,
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <TouchApp fontSize="small" sx={{ color: '#757575' }} />
      </Box>
      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="right-start"
      >
        <Box
          sx={{
            minWidth: 'fit-content',
            maxWidth: { xs: '90vw', sm: 'none' },
            backgroundColor: '#e8e4e4',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            p: 1,
            zIndex: 1300,
          }}
        >
          <Box sx={{ p: 1 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
              Gauge Information
            </Typography>
            <Box sx={{ mb: 1 }}>
              <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                • Hover over gauge needle for detailed data
              </Typography>
            </Box>
            <Box>
              <Typography
                variant="body2"
                sx={{ fontWeight: 'medium', mb: 0.5 }}
              >
                Color Codes:
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                  🔴 Red: Below 95%
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                  🟡 Amber: 95% - 100%
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                  🟢 Green: Above 100%
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Popper>
    </>
  );
}

export default GuageContainer;
